import { render, staticRenderFns } from "./DairyDetail.vue?vue&type=template&id=94ff9496&scoped=true&"
import script from "./DairyDetail.vue?vue&type=script&lang=js&"
export * from "./DairyDetail.vue?vue&type=script&lang=js&"
import style0 from "./DairyDetail.vue?vue&type=style&index=0&id=94ff9496&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ff9496",
  null
  
)

export default component.exports